module.exports = __webpack_public_path__ + "img/money.fa1c45d1.svg";